import { Component, OnInit } from '@angular/core';
import {PageDTO} from '../../../../common/dtos/PageDTO';
import {TranslateService} from '@ngx-translate/core';
import {EnrolleListService} from '../../../user/services/enrolle-list.service';
import {CenterProfessionService} from '../../../../common_services/center-profession.service';
import {CollegeInfoService} from '../../services/college-info.service';
import {EnrollApplicationService} from '../../services/enroll-application.service';
import {DictionaryService} from '../../../shared/services/dictionary.service';
import {MatDialog} from '@angular/material';
import {Utils} from '../../../../common/services/Utils';
import {LangChange} from '../../../../lang-change';
import {Language} from '../../../../common/models/language';

@Component({
  selector: 'app-public-applicants-list',
  templateUrl: './public-applicants-list.component.html',
  styleUrls: ['./public-applicants-list.component.scss']
})
export class PublicApplicantsListComponent extends LangChange implements OnInit {
  langId: any;
  page: PageDTO = new PageDTO();
  enrolls: any[] = [];
  totalElements: 0;
  quotaFullName = '';
  dialogRef: any;

  // region Dictionaries
  professions: any[] = [];
  specializations: any[] = [];
  study_languages: any[] = [];
  education_types: any[] = [];
  quotas: any[] = [];
  universityList: College[];
  // endregion Dictionaries
  filteredCenterProfessions: number[];
  constructor(public _translateService: TranslateService,
              private _enrolleListService: EnrolleListService,
              private _professionService: CenterProfessionService,
              private _collegeInfoService: CollegeInfoService,
              private _enrollApplicationService: EnrollApplicationService,
              private _dictionaryService: DictionaryService,
              public dialog: MatDialog,
              private _utils: Utils) {
    super(_translateService);
    this.page.size = 20;
    this.page.filter = {
      college: 0,
      status: 0,
      searchText: '',
      applicationDateFrom: null,
      applicationDateTo: null,
      specialty: 0,
      specialization: 0,
      // study_form: 0,
      study_language: 0,
      educated: 1,
      // payment_form: 0,
      quotaId: 0,
      gender: 0,
      source: 0,
      priorityCollege: 0
    };
    this.page.sorting = {};
    this.page.sorting['profession.code'] = 'ASC';
    // this.page.sorting['specialization.code'] = 'ASC';
    // this.page.sorting['studylanguageid'] = 'DESC';
    // this.page.sorting['educated.id'] = 'ASC';
    // this.page.sorting['gpa'] = 'DESC';
    // this.page.sorting['enrollInfo.certificateaveragescore'] = 'DESC';
     this.page.sorting['lastname'] = 'ASC';
     this.page.sorting['firstname'] = 'ASC';
     this.page.sorting['patronymic'] = 'ASC';
    // this.page.sorting['college.nameRu'] = 'ASC';
    // this.page.sorting['quotaId'] = 'ASC';
    // this.page.sorting['applicantInfo.submittedTime'] = 'ASC';
  }

  ngOnInit() {
    this.langId = this._translateService.currentLang;

    this.loadDictionaries();

    this.loadEnrollsList();
  }

  loadDictionaries() {
    this.loadCollegeList();
    this.loadCenterProfession();
    this.loadCenterAdmissionQuotas();
    this.loadStudyLanguages();
    this.loadEducationTypes();
    this.loadSpecializations();
  }

  loadEnrollsList() {
    this._enrolleListService.getApplicantsPublicList(this.page).subscribe(data => {
      if (data) {
        this.enrolls = data.dtoList;
        this.totalElements = data.totalElements;
        this.translateEnrollsSpecilizations();
      }
    }, error => {
      this._utils.notifyError('error_occurred', '');
    });
  }

  filterProfessions() {
    console.log('');
  }

  // region Load Dictionaries
  loadCollegeList() {
    this.universityList = [];
    this._collegeInfoService.getColleges(this.langId).subscribe(
      response => {
        this.universityList = response['dictionaryCollege'];
      },
      err => {
        console.log(err);
      }
    );
  }

  loadCenterProfession() {
    const filter = {
      collegeId: this.page.filter.college,
      hasCount: true,
      // studyLanguageId: this.page.filter.study_language,
      // educatedId: this.page.filter.educated
    };
    this._professionService.getCenterProfessionsWithGrant(filter).subscribe(data => {
        this.professions = this._utils.translateListWithSort(data, 'name');
        this.professions.map((i) => {
          i.fullName = i.code + ' ' + i.name;
          return i;
        });
      }, err => {
        console.log('EnrollCabinetComponent _centerProfessionService.getListByCollegeId() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }

  loadFilteredCenterProfession() {
    const filter = {
      collegeId: this.page.filter.college,
      hasCount: true,
      studyLanguageId: this.page.filter.study_language,
      educatedId: this.page.filter.educated
    };
    this._professionService.getCenterProfessionsWithGrantOnlyIds(filter).subscribe(data => {
        this.filteredCenterProfessions = data;
      }, err => {
        console.log('EnrollCabinetComponent _centerProfessionService.getListByCollegeId() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }

  loadSpecializations() {
    const filter = {centerProfessionId: this.page.filter.specialty};
    this._enrollApplicationService.getCenterSpecializationsByProfId(filter).subscribe(data => {
      this.specializations = data;
      this.specializations.unshift({id: 0, nameRu: 'Все', nameKz: 'Барлығы', nameEn: 'All', name: '', code: ''});
      Language.updateListLocalizedName(this.specializations);
      this.specializations.map((i) => {
        i.name = i.code + ' ' + i.name;
        return i;
      });
    });
  }

  loadCenterAdmissionQuotas() {
    this._dictionaryService.getCenterAdmissionQuotasList().subscribe(data => {
        this.quotas = data;
        Language.updateListLocalizedName(this.quotas);
      }, err => {
        console.log('EnrolleListComponent loadCenterAdmissionQuotas() _dictionaryService.getCenterAdmissionQuotasList() error', err);
        this._utils.notifyError(this._translateService.instant('error_occurred'), '');
      }
    );
  }

  loadStudyLanguages() {
    /*    this._dictionaryService.getCenterStudyLanguagesList().subscribe(data => {
            this.study_languages = data;
            if (this.study_languages) {
              this.study_languages = this.study_languages.filter(obj => obj.id == 1 || obj.id == 2);
            }
            Language.updateListLocalizedName(this.study_languages);
          }, err => {
            console.log('EnrolleListComponent loadStudyLanguages() _dictionaryService.getCenterStudyLanguagesList() error', err);
            this._utils.notifyError(this._translateService.instant('error_occurred'), '');
          }
        );*/
    this.study_languages = [
      {id: 0, nameRu: 'Все', nameKz: 'Барлығы', nameEn: 'All', name: ''},
      {id: 1, nameRu: 'Русский', nameKz: 'Орысша', nameEn: 'Russian', name: ''},
      {id: 2, nameRu: 'Казахский', nameKz: 'Қазақша', nameEn: 'Kazakh', name: ''}
    ];
    if (window.location.hostname === 'zhetysu.pem.kz') {
      this.study_languages.push({id: 40, nameRu: 'Уйгурский', nameKz: 'Ұйғыр', nameEn: 'Uyghur', name: ''});
    }
    Language.updateListLocalizedName(this.study_languages);
  }

  loadEducationTypes() {
    this._enrollApplicationService.getDicEducatedList().subscribe(data => {
      this.education_types = data.filter(h => h.id !== 4 && h.id !== 5);
      Language.updateListLocalizedName(this.education_types);
    });
  }
  // endregion Load Dictionaries

  // region Get Names
  getCollegeName(collegeId) {
    if (collegeId > 0 && this.universityList.filter(obj => obj.id == collegeId)[0]) {
      return this.universityList.filter(obj => obj.id == collegeId)[0].name;
    } else {
      return '';
    }
  }

  getProfessionName(professionId) {
    if (professionId > 0 && this.professions.filter(obj => obj.id == professionId)[0]) {
      return this.professions.filter(obj => obj.id == professionId)[0].code + ' ' + this.professions.filter(obj => obj.id == professionId)[0].name;
    } else {
      return '';
    }
  }

  getQuotaName(quotaId) {
    if (quotaId > 0 && this.quotas) {
      return this.quotas.filter(obj => obj.id == quotaId)[0].name;
    } else {
      return '-';
    }
  }

  getStudyLangName(langId) {
    switch (langId) {
      case Language.RUSSIAN.id :
        return this._translateService.instant('lang_ru');
      case Language.KAZAKH.id :
        return this._translateService.instant('lang_kz');
    }
  }

  getEducatedName(educatedID) {
    switch (educatedID) {
      case 1:
        return this._translateService.instant('basic_secondary_education_9');
      case 2:
        return this._translateService.instant('common_secondary_education_11');
      case 3:
        return this._translateService.instant('technical_and_professional_education');
      case 4:
        return this._translateService.instant('post_secondary_higher_education');
      case 5:
        return this._translateService.instant('primary_education');
    }

    return '';
  }
  // endregion GetNames

  openDialog(content, quotaId) {
    this.quotaFullName = this.getQuotaName(quotaId);
    this.dialogRef = this.dialog.open(content, {
      width: '300px',
      data: {}
    });
  }

  onLangChange(language: Language): void {
    this.langId = this._translateService.currentLang;

    this.loadDictionaries();
    this.loadSpecializations();
    this.translateEnrollsSpecilizations();
    /*
        this.translateEnrollsSpecilizations();
        Language.updateListLocalizedName(this.specializations);
        this.specializations.map((i) => {
          i.name = i.code + ' ' + i.name;
          return i;
        });
        this.specializations = [...this.specializations, {}];
        this.specializations.pop();
    */
  }

  private translateEnrollsSpecilizations() {
    this.enrolls.forEach(item => {
      if (item.specialization) {
        item.specialization.name = this._utils.getMultiValue(item.specialization, 'name');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/public-applicants-list/public-applicants-list.component.ts